import {CommonModule} from '@angular/common';
import {Component, inject, OnInit, Input} from '@angular/core';
import {
    AccessType,
    AuthService,
    ChecklistClient, ChecklistCondition,
    ChecklistConditionExportQuery,
    ChecklistConditionQuery, IMyScoreShiftQuery, ITrendingQuery,
    PermissionType,
} from "@services";
import {ChecklistConditionTrendingQuery} from "@services";
import {ScoreDashboardComponent} from "../../../components/library/score-dashboard/score-dashboard.component";

export function checklistConditionPalette(): Record<string, string> {
    const getColor = (name: string) => getComputedStyle(document.body).getPropertyValue(name).trim();
    return {
        [ChecklistCondition.Ok]: getColor('--bs-success'),
        [ChecklistCondition.Defect]: getColor('--bs-danger'),
        [ChecklistCondition.Repaired]: getColor('--bs-warning'),
    };
}

@Component({
    selector: 'app-checklist-condition-score',
    imports: [CommonModule, ScoreDashboardComponent],
    templateUrl: './checklist-condition.component.html'
})
export class ChecklistConditionComponent implements OnInit {
    private checklistClient = inject(ChecklistClient)
    protected authService = inject(AuthService);

    @Input() employeeId: string | null;
    @Input() daysLookBack: number = 0;

    palette: Record<string, string> = {};

    loadScoreData = (query: IMyScoreShiftQuery) => {
        return this.checklistClient.getChecklistConditionScore(new ChecklistConditionQuery(query));
    }

    loadTrendingData = (query: ITrendingQuery) => {
        return this.checklistClient.getChecklistConditionTrending(new ChecklistConditionTrendingQuery(query));
    }

    exportData = (from: Date, to: Date, userId: string | null) => {
        const query = new ChecklistConditionExportQuery({ from, to, userId });
        return this.checklistClient.exportChecklistCondition(query);
    }

    ngOnInit(): void {
        this.palette = checklistConditionPalette();

        if (!this.authService.checkPermission(PermissionType.ChecklistCondition, AccessType.Manage)) {
            this.employeeId = this.authService.userId;
        }
    }
}

